"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/system/Box"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var FacebookRounded_1 = __importDefault(require("@mui/icons-material/FacebookRounded"));
var MailOutlineRounded_1 = __importDefault(require("@mui/icons-material/MailOutlineRounded"));
var WhatsappRounded_1 = __importDefault(require("@mui/icons-material/WhatsappRounded"));
/** Represents three share link icons horizontally arranged */
var Component = function (p) {
    return (Preact.h(Box_1.default, { display: "flex", justifyContent: "center", alignItems: "center", gap: "20px", sx: p.sx },
        Preact.h(Link_1.default, { href: p.hrefMail, target: "_blank" },
            Preact.h(Box_1.default, { borderRadius: "50%", sx: { background: '#6e6c6b', margin: '5px' }, width: "50px", height: "50px" },
                Preact.h(MailOutlineRounded_1.default, { sx: {
                        color: 'white',
                        padding: '10px',
                        display: 'flex',
                    }, style: { fontSize: 30 } }))),
        Preact.h(Link_1.default, { href: p.hrefWhatsapp, target: "_blank" },
            Preact.h(Box_1.default, { borderRadius: "50%", sx: { background: '#25D366', margin: '5px' }, width: "50px", height: "50px" },
                Preact.h(WhatsappRounded_1.default, { sx: {
                        color: 'white',
                        padding: '10px',
                        display: 'flex',
                    }, style: { fontSize: 30 } }))),
        Preact.h(Link_1.default, { href: p.hrefFacebook, target: "_blank" },
            Preact.h(FacebookRounded_1.default, { sx: {
                    color: '#4267B2',
                }, style: { fontSize: 60 } }))));
};
exports.Component = Component;
